(function () {
  function parsePriceInput(value) {
    if (value === null || value === undefined || String(value).trim() === '') {
      return null;
    }

    const parsed = parseFloat(String(value).replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : null;
  }

  function formatPrice(value) {
    return Number(value).toFixed(2);
  }

  function formatMoneyDisplay(value) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  function renderPriceRangePips(pipsRoot, minVal, maxVal) {
    if (!pipsRoot) {
      return;
    }

    const markerPositions = [0, 20, 40, 60, 80, 100];
    const parts = markerPositions.map((position) => {
      const markerSize = position === 0 || position === 100 ? 'large' : 'normal';
      return `<div class="noUi-marker noUi-marker-horizontal noUi-marker-${markerSize}" style="left: ${position}%;"></div>`;
    });

    parts.push(
      `<div class="noUi-value noUi-value-horizontal noUi-value-large" data-brand-bs-pip-min data-value="${formatPrice(minVal)}" style="left: 0%;">${formatMoneyDisplay(minVal)}</div>`
    );
    parts.push(
      `<div class="noUi-value noUi-value-horizontal noUi-value-large" data-brand-bs-pip-max data-value="${formatPrice(maxVal)}" style="left: 100%;">${formatMoneyDisplay(maxVal)}</div>`
    );

    pipsRoot.innerHTML = parts.join('');
    pipsRoot.hidden = false;
  }

  function updatePriceRangePipValues(pipsRoot, minVal, maxVal) {
    if (!pipsRoot) {
      return;
    }

    const minPip = pipsRoot.querySelector('[data-brand-bs-pip-min]');
    const maxPip = pipsRoot.querySelector('[data-brand-bs-pip-max]');

    if (minPip) {
      minPip.dataset.value = formatPrice(minVal);
      minPip.textContent = formatMoneyDisplay(minVal);
    }

    if (maxPip) {
      maxPip.dataset.value = formatPrice(maxVal);
      maxPip.textContent = formatMoneyDisplay(maxVal);
    }
  }

  function toCents(dollars) {
    return Math.round(dollars * 100);
  }

  function getProductCollections(item) {
    return (item.dataset.collections || '')
      .split('||')
      .map((handle) => handle.trim())
      .filter(Boolean);
  }

  function productMatchesPrice(item, minCents, maxCents) {
    const priceMin = parseInt(item.dataset.priceMin, 10) || 0;

    if (minCents !== null && priceMin < minCents) {
      return false;
    }

    if (maxCents !== null && priceMin > maxCents) {
      return false;
    }

    return true;
  }

  function productMatchesCollections(item, selectedCollectionHandles) {
    if (!selectedCollectionHandles.length) {
      return true;
    }

    const productCollections = getProductCollections(item);
    return selectedCollectionHandles.some((handle) => productCollections.includes(handle));
  }

  function itemMatchesFilters(item, filters) {
    return (
      productMatchesPrice(item, filters.minCents, filters.maxCents) &&
      productMatchesCollections(item, filters.selectedCollections)
    );
  }

  function normalizeSearchQuery(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function productMatchesSearch(item, query) {
    if (!query) {
      return true;
    }

    const haystack = (item.dataset.searchText || '').toLowerCase();
    const terms = query.split(' ').filter(Boolean);
    return terms.every((term) => haystack.includes(term));
  }

  function itemMatchesSearchFilters(item, filters) {
    return itemMatchesFilters(item, filters) && productMatchesSearch(item, filters.searchQuery);
  }

  function getMatchingItems(category, filters) {
    return Array.from(category.querySelectorAll('.brand-bs-category-item')).filter((item) =>
      itemMatchesFilters(item, filters)
    );
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  const CLEAR_FILTER_SVG =
    '<svg viewBox="0 0 50 50" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M25.5 6C15 6 6.5 14.5 6.5 25C6.5 35.5 15 44 25.5 44C36 44 44.5 35.5 44.5 25C44.5 14.5 36 6 25.5 6ZM34.4 31.9L32.5 33.8L25.6 26.9L18.7 33.8L16.8 31.9L23.7 25L16.8 18.1L18.7 16.2L25.6 23.1L32.5 16.2L34.4 18.1L27.4 25L34.4 31.9Z"></path></svg>';

  function getCarModelLabel(wrap, handle) {
    const checkboxes = wrap.querySelectorAll('[data-brand-bs-car-model-checkbox]');

    for (const checkbox of checkboxes) {
      if (checkbox.value === handle) {
        return (
          checkbox.closest('label')?.querySelector('.brand-bs-car-model-text')?.textContent?.trim() ||
          handle
        );
      }
    }

    return handle;
  }

  function buildActiveFilterChips(wrap, filterState) {
    const labels = window.brandBsLabels || {};
    const chips = [];

    filterState.selectedCollections.forEach((handle) => {
      const label = getCarModelLabel(wrap, handle);
      chips.push({
        type: 'car-model',
        value: handle,
        filterLabel: labels.carModel || 'Car Model',
        label,
        ariaLabel: `Remove filter value: ${label}`,
      });
    });

    if (filterState.minCents !== null || filterState.maxCents !== null) {
      const bounds = filterState.priceBounds || { min: 0, max: 0 };
      const minDollars = filterState.minCents !== null ? filterState.minCents / 100 : bounds.min;
      const maxDollars = filterState.maxCents !== null ? filterState.maxCents / 100 : bounds.max;
      const priceLabel = `$${formatPrice(minDollars)} - $${formatPrice(maxDollars)}`;

      chips.push({
        type: 'price',
        value: '',
        filterLabel: labels.price || 'Price',
        label: priceLabel,
        ariaLabel: `Remove price filter: ${priceLabel}`,
      });
    }

    return chips;
  }

  function renderActiveFiltersList(list, chips) {
    const labels = window.brandBsLabels || {};
    list.innerHTML = '';

    if (!chips.length) {
      return;
    }

    const clearItem = document.createElement('li');
    clearItem.className = 'selected-item gf-option-label';
    clearItem.innerHTML = `<a tabindex="0" class="clear-refinements" data-brand-bs-clear-all aria-label="${escapeHtml(labels.clearAll || 'Clear all filters')}">${escapeHtml(labels.clearAll || 'Clear All')}</a>`;
    list.appendChild(clearItem);

    chips.forEach((chip) => {
      const item = document.createElement('li');
      item.className = 'selected-item gf-option-label';
      item.innerHTML = `
        <a
          tabindex="0"
          class="refine-by-multi-filter"
          data-brand-bs-remove-filter
          data-filter-type="${escapeHtml(chip.type)}"
          data-filter-value="${escapeHtml(chip.value)}"
          aria-label="${escapeHtml(chip.ariaLabel)}"
        >
          <span class="selected-item">
            <span class="hidden-xs">${escapeHtml(chip.filterLabel)}</span>
            <span class="gf-label">${escapeHtml(chip.label)}</span>
          </span>
          <span class="gf-clear">${CLEAR_FILTER_SVG}</span>
        </a>`;
      list.appendChild(item);
    });
  }

  function updateActiveFilters(wrap, filterState) {
    const roots = wrap.querySelectorAll('[data-brand-bs-active-filters]');
    const chips = buildActiveFilterChips(wrap, filterState);

    roots.forEach((root) => {
      const list = root.querySelector('[data-brand-bs-active-filters-list]');

      if (!list) {
        return;
      }

      if (!chips.length) {
        root.hidden = true;
        list.innerHTML = '';
        return;
      }

      root.hidden = false;
      renderActiveFiltersList(list, chips);
    });
  }

  function initActiveFilters(wrap, filterState, filterControls, applyFilters) {
    wrap.addEventListener('click', (event) => {
      const clearAll = event.target.closest('[data-brand-bs-clear-all]');

      if (clearAll && wrap.contains(clearAll)) {
        event.preventDefault();
        filterControls.clearAll();
        applyFilters();
        return;
      }

      const removeButton = event.target.closest('[data-brand-bs-remove-filter]');

      if (removeButton && wrap.contains(removeButton)) {
        event.preventDefault();
        filterControls.removeFilter(removeButton.dataset.filterType, removeButton.dataset.filterValue);
        applyFilters();
      }
    });
  }

  function isMobileCategoryScroll() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getMobileCarouselGrid(category) {
    return category.querySelector('.brand-best-sellers-category__grid');
  }

  function getMobileCarouselScrollStep(grid) {
    const firstItem = grid.querySelector('.brand-bs-category-item:not([hidden])');

    if (!firstItem) {
      return grid.clientWidth;
    }

    const gridStyles = window.getComputedStyle(grid);
    const gap = parseFloat(gridStyles.columnGap || gridStyles.gap || '0') || 0;

    return firstItem.offsetWidth + gap;
  }

  function mobileCarouselNeedsNav(grid, matchCount) {
    if (!grid || matchCount <= 0) {
      return false;
    }

    if (grid.scrollWidth > grid.clientWidth + 1) {
      return true;
    }

    return matchCount > 2;
  }

  function setCarouselArrowState(button, { hidden, inactive }) {
    if (!button) {
      return;
    }

    button.hidden = hidden;
    button.disabled = inactive;
    button.classList.toggle('brand-bs-carousel__btn--inactive', !hidden && inactive);
  }

  function syncMobileCarouselNav(category, matchCount) {
    const prev = category.querySelector('[data-brand-bs-carousel-prev]');
    const next = category.querySelector('[data-brand-bs-carousel-next]');
    const grid = getMobileCarouselGrid(category);
    const showNav = mobileCarouselNeedsNav(grid, matchCount);

    if (!showNav || !grid) {
      setCarouselArrowState(prev, { hidden: true, inactive: true });
      setCarouselArrowState(next, { hidden: true, inactive: true });
      return;
    }

    const maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
    const atStart = grid.scrollLeft <= 1;
    const atEnd = grid.scrollLeft >= maxScroll - 1;

    setCarouselArrowState(prev, { hidden: false, inactive: atStart });
    setCarouselArrowState(next, { hidden: false, inactive: atEnd || maxScroll <= 0 });
  }

  function scrollMobileCarousel(category, direction) {
    const grid = getMobileCarouselGrid(category);

    if (!grid) {
      return;
    }

    grid.scrollBy({
      left: direction * getMobileCarouselScrollStep(grid),
      behavior: 'smooth',
    });
  }

  function initMobileCarouselScrollSync(category, filterState) {
    const grid = getMobileCarouselGrid(category);

    if (!grid || grid.dataset.gcaBsScrollBound) {
      return;
    }

    grid.dataset.gcaBsScrollBound = '1';

    let rafId = null;

    const syncNav = () => {
      const matchingItems = getMatchingItems(category, filterState);
      syncMobileCarouselNav(category, matchingItems.length);
    };

    grid.addEventListener(
      'scroll',
      () => {
        if (!isMobileCategoryScroll()) {
          return;
        }

        if (rafId) {
          cancelAnimationFrame(rafId);
        }

        rafId = requestAnimationFrame(syncNav);
      },
      { passive: true }
    );

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(() => {
        if (!isMobileCategoryScroll()) {
          return;
        }

        syncNav();
      });

      resizeObserver.observe(grid);
    }
  }

  function updateCarouselNav(category, page, totalPages, matchCount, limit) {
    const prev = category.querySelector('[data-brand-bs-carousel-prev]');
    const next = category.querySelector('[data-brand-bs-carousel-next]');
    const showNav = matchCount > limit;
    const atStart = page <= 0;
    const atEnd = page >= totalPages - 1;

    if (prev) {
      setCarouselArrowState(prev, { hidden: !showNav, inactive: showNav && atStart });
    }

    if (next) {
      setCarouselArrowState(next, { hidden: !showNav, inactive: showNav && atEnd });
    }
  }

  function updateCategory(category, filters, pageOverride) {
    const limit = parseInt(category.dataset.productLimit, 10) || 4;
    const items = Array.from(category.querySelectorAll('.brand-bs-category-item'));
    const emptyFiltered = category.querySelector('.brand-best-sellers-category__empty--filtered');
    const viewAll = category.querySelector('.brand-best-sellers-category__view-all');
    const hasPriceFilter = filters.minCents !== null || filters.maxCents !== null;
    const hasCollectionFilter = filters.selectedCollections.length > 0;
    const hasActiveFilter = hasPriceFilter || hasCollectionFilter;

    const matchingItems = items.filter((item) => itemMatchesFilters(item, filters));
    const totalPages = Math.max(1, Math.ceil(matchingItems.length / limit) || 1);
    const isMobile = isMobileCategoryScroll();

    if (isMobile) {
      items.forEach((item) => {
        item.hidden = true;
      });

      matchingItems.forEach((item) => {
        item.hidden = false;
      });

      if (emptyFiltered) {
        emptyFiltered.hidden = !(hasActiveFilter && matchingItems.length === 0 && items.length > 0);
      }

      if (viewAll) {
        viewAll.hidden = matchingItems.length === 0;
      }

      const grid = getMobileCarouselGrid(category);

      if (grid && pageOverride !== null && pageOverride !== undefined) {
        grid.scrollLeft = 0;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          syncMobileCarouselNav(category, matchingItems.length);
        });
      });
      return;
    }

    let page =
      pageOverride !== null && pageOverride !== undefined
        ? pageOverride
        : parseInt(category.dataset.carouselPage, 10) || 0;

    if (page >= totalPages) {
      page = totalPages - 1;
    }
    if (page < 0) {
      page = 0;
    }

    category.dataset.carouselPage = String(page);

    items.forEach((item) => {
      item.hidden = true;
    });

    const start = page * limit;
    const end = start + limit;

    matchingItems.forEach((item, index) => {
      if (index >= start && index < end) {
        item.hidden = false;
      }
    });

    if (emptyFiltered) {
      emptyFiltered.hidden = !(hasActiveFilter && matchingItems.length === 0 && items.length > 0);
    }

    if (viewAll) {
      viewAll.hidden = matchingItems.length === 0;
    }

    updateCarouselNav(category, page, totalPages, matchingItems.length, limit);
  }

  function initCategoryCarousels(categories, filterState) {
    categories.forEach((category) => {
      const prev = category.querySelector('[data-brand-bs-carousel-prev]');
      const next = category.querySelector('[data-brand-bs-carousel-next]');

      initMobileCarouselScrollSync(category, filterState);

      if (prev && !prev.dataset.gcaBsBound) {
        prev.dataset.gcaBsBound = '1';
        prev.addEventListener('click', () => {
          if (isMobileCategoryScroll()) {
            scrollMobileCarousel(category, -1);
            return;
          }

          const currentPage = parseInt(category.dataset.carouselPage, 10) || 0;
          updateCategory(category, filterState, Math.max(0, currentPage - 1));
        });
      }

      if (next && !next.dataset.gcaBsBound) {
        next.dataset.gcaBsBound = '1';
        next.addEventListener('click', () => {
          if (isMobileCategoryScroll()) {
            scrollMobileCarousel(category, 1);
            return;
          }

          const limit = parseInt(category.dataset.productLimit, 10) || 4;
          const matchingItems = getMatchingItems(category, filterState);
          const totalPages = Math.max(1, Math.ceil(matchingItems.length / limit) || 1);
          const currentPage = parseInt(category.dataset.carouselPage, 10) || 0;
          updateCategory(category, filterState, Math.min(totalPages - 1, currentPage + 1));
        });
      }

      category.dataset.carouselPage = '0';
      updateCategory(category, filterState, 0);
    });
  }

  function getProductPriceBounds() {
    const items = document.querySelectorAll('.brand-bs-category-item, .brand-bs-search-item');
    let min = Infinity;
    let max = 0;

    items.forEach((item) => {
      const priceMin = (parseInt(item.dataset.priceMin, 10) || 0) / 100;
      const priceMax = (parseInt(item.dataset.priceMax, 10) || parseInt(item.dataset.priceMin, 10) || 0) / 100;
      if (priceMin < min) min = priceMin;
      if (priceMax > max) max = priceMax;
    });

    if (!Number.isFinite(min) || min === Infinity) {
      min = 0;
    }

    if (max <= min) {
      max = min + 1;
    }

    return { min, max };
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initPriceFilterUI(root, applyFilter) {
    const details = root.querySelector('[data-brand-bs-price-block]');
    const toggle = root.querySelector('[data-brand-bs-price-toggle]');
    const minInput = root.querySelector('[data-brand-bs-price-min]');
    const maxInput = root.querySelector('[data-brand-bs-price-max]');
    const minRange = root.querySelector('[data-brand-bs-range-min]');
    const maxRange = root.querySelector('[data-brand-bs-range-max]');
    const connect = root.querySelector('[data-brand-bs-range-connect]');
    const pipsRoot = root.querySelector('[data-brand-bs-range-pips]');

    if (!details || !minInput || !maxInput || !minRange || !maxRange || !connect) {
      return;
    }

    const bounds = getProductPriceBounds();
    const step = 1;

    minRange.min = bounds.min;
    minRange.max = bounds.max;
    minRange.step = step;
    maxRange.min = bounds.min;
    maxRange.max = bounds.max;
    maxRange.step = step;

    minRange.value = bounds.min;
    maxRange.value = bounds.max;
    minInput.value = formatPrice(bounds.min);
    maxInput.value = formatPrice(bounds.max);

    function updateConnect() {
      const minVal = parseFloat(minRange.value);
      const maxVal = parseFloat(maxRange.value);
      const span = bounds.max - bounds.min || 1;
      const left = ((minVal - bounds.min) / span) * 100;
      const right = 100 - ((maxVal - bounds.min) / span) * 100;
      connect.style.left = `${left}%`;
      connect.style.right = `${right}%`;
    }

    function syncFromRanges() {
      let minVal = parseFloat(minRange.value);
      let maxVal = parseFloat(maxRange.value);

      if (minVal > maxVal) {
        if (document.activeElement === minRange) {
          maxVal = minVal;
          maxRange.value = maxVal;
        } else {
          minVal = maxVal;
          minRange.value = minVal;
        }
      }

      minInput.value = formatPrice(minVal);
      maxInput.value = formatPrice(maxVal);
      updateConnect();
      updatePriceRangePipValues(pipsRoot, minVal, maxVal);
      applyFilter(minVal, maxVal, bounds);
    }

    function syncFromInputs() {
      let minVal = parsePriceInput(minInput.value);
      let maxVal = parsePriceInput(maxInput.value);

      if (minVal === null) minVal = bounds.min;
      if (maxVal === null) maxVal = bounds.max;

      minVal = clamp(minVal, bounds.min, bounds.max);
      maxVal = clamp(maxVal, bounds.min, bounds.max);

      if (minVal > maxVal) {
        const temp = minVal;
        minVal = maxVal;
        maxVal = temp;
      }

      minRange.value = minVal;
      maxRange.value = maxVal;
      minInput.value = formatPrice(minVal);
      maxInput.value = formatPrice(maxVal);
      updateConnect();
      updatePriceRangePipValues(pipsRoot, minVal, maxVal);
      applyFilter(minVal, maxVal, bounds);
    }

    minRange.addEventListener('input', syncFromRanges);
    maxRange.addEventListener('input', syncFromRanges);
    minInput.addEventListener('input', syncFromInputs);
    maxInput.addEventListener('input', syncFromInputs);
    minInput.addEventListener('change', syncFromInputs);
    maxInput.addEventListener('change', syncFromInputs);

    details.addEventListener('toggle', () => {
      if (toggle) {
        toggle.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      }
    });

    updateConnect();
    renderPriceRangePips(pipsRoot, bounds.min, bounds.max);
    applyFilter(bounds.min, bounds.max, bounds);

    return {
      reset() {
        minRange.value = bounds.min;
        maxRange.value = bounds.max;
        minInput.value = formatPrice(bounds.min);
        maxInput.value = formatPrice(bounds.max);
        updateConnect();
        updatePriceRangePipValues(pipsRoot, bounds.min, bounds.max);
        applyFilter(bounds.min, bounds.max, bounds);
      },
      getBounds() {
        return bounds;
      },
    };
  }

  function initCarModelFilterUI(root, applyFilter) {
    const details = root.querySelector('[data-brand-bs-car-model-block]');
    const toggle = root.querySelector('[data-brand-bs-car-model-toggle]');
    const checkboxes = Array.from(root.querySelectorAll('[data-brand-bs-car-model-checkbox]'));

    if (!details || !checkboxes.length) {
      return;
    }

    function syncFromCheckboxes() {
      const selectedCollectionHandles = checkboxes
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value);

      applyFilter(selectedCollectionHandles);
    }

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', syncFromCheckboxes);
    });

    details.addEventListener('toggle', () => {
      if (toggle) {
        toggle.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      }
    });

    syncFromCheckboxes();

    return {
      clearAll() {
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
        syncFromCheckboxes();
      },
      uncheck(handle) {
        const checkbox = checkboxes.find((entry) => entry.value === handle);

        if (checkbox) {
          checkbox.checked = false;
          syncFromCheckboxes();
        }
      },
    };
  }

  function updateSearchResults(searchRoot, filters) {
    const items = Array.from(searchRoot.querySelectorAll('.brand-bs-search-item'));
    const emptyState = searchRoot.querySelector('[data-brand-bs-search-empty]');
    const countNode = document.querySelector('[data-brand-bs-search-count]');
    const matchingItems = items.filter((item) => itemMatchesSearchFilters(item, filters));

    items.forEach((item) => {
      item.hidden = true;
    });

    matchingItems.forEach((item) => {
      item.hidden = false;
    });

    if (emptyState) {
      emptyState.hidden = matchingItems.length > 0;
    }

    if (countNode) {
      countNode.textContent =
        matchingItems.length === 1
          ? '1 product found'
          : `${matchingItems.length} products found`;
    }
  }

  function setSearchMode(wrap, filterState, active) {
    const categories = wrap.querySelector('[data-brand-bs-categories]');
    const searchResults = wrap.querySelector('[data-brand-bs-search-results]');

    if (categories) {
      categories.hidden = active;
    }

    if (searchResults) {
      searchResults.hidden = !active;
    }

    filterState.searchActive = active;

    if (active) {
      updateSearchResults(searchResults, filterState);
    } else {
      const categoriesList = wrap.querySelectorAll('.brand-best-sellers-category[data-product-limit]');
      categoriesList.forEach((category) => {
        updateCategory(category, filterState, 0);
      });
    }
  }

  function initSearchUI(wrap, filterState, applyFilters) {
    const input = wrap.querySelector('[data-brand-bs-search-input]');
    const clearButton = wrap.querySelector('[data-brand-bs-search-clear]');
    const form = wrap.querySelector('[data-brand-bs-search-form]');

    if (!input) {
      return;
    }

    function syncClearButton() {
      if (clearButton) {
        clearButton.hidden = input.value.trim().length === 0;
      }
    }

    function handleSearchInput() {
      filterState.searchQuery = normalizeSearchQuery(input.value);
      syncClearButton();

      if (filterState.searchQuery) {
        setSearchMode(wrap, filterState, true);
      } else {
        setSearchMode(wrap, filterState, false);
      }

      applyFilters();
    }

    input.addEventListener('input', handleSearchInput);

    if (clearButton) {
      clearButton.addEventListener('click', () => {
        input.value = '';
        handleSearchInput();
        input.focus();
      });
    }

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        handleSearchInput();
      });
    }

    syncClearButton();

    return {
      clear() {
        input.value = '';
        handleSearchInput();
      },
    };
  }

  function initMobileFilterDrawer(wrap) {
    const drawer = wrap.querySelector('[data-brand-bs-filter-drawer]');
    const openButton = wrap.querySelector('[data-brand-bs-filter-open]');

    if (!drawer || !openButton) {
      return;
    }

    const panel = drawer.querySelector('.brand-bs-filter-drawer__panel');
    const closeTargets = drawer.querySelectorAll('[data-brand-bs-filter-close]');
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    function isMobile() {
      return mobileQuery.matches;
    }

    function setOpen(isOpen) {
      drawer.classList.toggle('is-open', isOpen);
      openButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isMobile()) {
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        document.body.classList.toggle('brand-bs-filter-open', isOpen);
      } else {
        drawer.removeAttribute('aria-hidden');
        document.body.classList.remove('brand-bs-filter-open');
      }
    }

    function openDrawer() {
      if (!isMobile()) {
        return;
      }
      setOpen(true);
    }

    function closeDrawer() {
      setOpen(false);
    }

    openButton.addEventListener('click', openDrawer);

    closeTargets.forEach((target) => {
      target.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    mobileQuery.addEventListener('change', () => {
      if (!isMobile()) {
        closeDrawer();
      }
    });

    setOpen(false);
  }

  function initBestSellersCollection() {
    const wrap = document.querySelector('.brand-bs-collection-wrap');
    if (!wrap) {
      return;
    }

    const url = new URL(window.location.href);
    if (url.searchParams.has('filter.v.price.gte') || url.searchParams.has('filter.v.price.lte')) {
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      const cleanUrl = url.pathname + (url.search || '');
      window.location.replace(cleanUrl);
      return;
    }

    const priceRoot = wrap.querySelector('#brand-bs-price-tree');
    const carModelRoot = wrap.querySelector('#brand-bs-car-model-tree');
    const categories = wrap.querySelectorAll('.brand-best-sellers-category[data-product-limit]');

    const filterState = {
      minCents: null,
      maxCents: null,
      selectedCollections: [],
      searchQuery: '',
      searchActive: false,
      priceBounds: null,
    };

    const filterControls = {
      priceApi: null,
      carModelApi: null,
      searchApi: null,
      clearAll() {
        filterState.minCents = null;
        filterState.maxCents = null;
        filterState.selectedCollections = [];

        if (this.priceApi) {
          this.priceApi.reset();
        }

        if (this.carModelApi) {
          this.carModelApi.clearAll();
        }

        if (this.searchApi) {
          this.searchApi.clear();
        }
      },
      removeFilter(type, value) {
        if (type === 'car-model' && this.carModelApi) {
          this.carModelApi.uncheck(value);
        } else if (type === 'price' && this.priceApi) {
          this.priceApi.reset();
        } else if (type === 'search' && this.searchApi) {
          this.searchApi.clear();
        }
      },
    };

    function applyFilters() {
      updateActiveFilters(wrap, filterState);

      if (filterState.searchActive) {
        updateSearchResults(wrap.querySelector('[data-brand-bs-search-results]'), filterState);
        return;
      }

      categories.forEach((category) => {
        updateCategory(category, filterState, 0);
      });
    }

    filterControls.searchApi = initSearchUI(wrap, filterState, applyFilters);
    initMobileFilterDrawer(wrap);
    initCategoryCarousels(categories, filterState);
    initActiveFilters(wrap, filterState, filterControls, applyFilters);

    if (priceRoot) {
      filterControls.priceApi = initPriceFilterUI(priceRoot, (minDollars, maxDollars, bounds) => {
        filterState.priceBounds = bounds;
        const atMin = Math.abs(minDollars - bounds.min) < 0.01;
        const atMax = Math.abs(maxDollars - bounds.max) < 0.01;
        filterState.minCents = atMin ? null : toCents(minDollars);
        filterState.maxCents = atMax ? null : toCents(maxDollars);
        applyFilters();
      });
      filterState.priceBounds = filterControls.priceApi.getBounds();
    }

    if (carModelRoot) {
      filterControls.carModelApi = initCarModelFilterUI(carModelRoot, (selectedCollectionHandles) => {
        filterState.selectedCollections = selectedCollectionHandles;
        applyFilters();
      });
    }

    const mobileScrollQuery = window.matchMedia('(max-width: 749px)');
    if (typeof mobileScrollQuery.addEventListener === 'function') {
      mobileScrollQuery.addEventListener('change', applyFilters);
    } else if (typeof mobileScrollQuery.addListener === 'function') {
      mobileScrollQuery.addListener(applyFilters);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestSellersCollection);
  } else {
    initBestSellersCollection();
  }
})();
